<template>
  <div>
      <div class="advertisement-head">
        <div class="container">
          <h1 class="module-title">{{blog.transTitle}}</h1>
          <div class="indicator-3">
            <span></span>
            <span class="green"></span>
            <span class="blue"></span>
          </div>
        </div>
      </div>
    <div class="advertisement-body">
      <div class="container">
        <div class="advertisement-item" v-for="page in pages">
          <div class="item-body">
            <h2>{{page.transTitle}}</h2>
            <div v-html="page.transContent"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    props: {
      pages: Array | Object,
      blog: Object
    },
    data () {
      return {
        baseUrl: process.env.VUE_APP_BACK_URL
      }
    },
    methods: {}
  }
</script>
